export default "__VITE_ASSET__DeJ8I3Ha__"